import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BeanMonitoryExclusion } from 'src/bean/BeanMonitoryExclusion';
import { environment } from 'src/environments/environment';

@Injectable()
export class ExclusaoMonitoriaDialogService {

    constructor(
    private http: HttpClient
    ) { }

    public getHeaders(){

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
        };

        return headers;
    }
    
    public solicitarExclusao(monitoryExclusion: BeanMonitoryExclusion):Observable<any> {
        const headers = this.getHeaders();
        let json = JSON.stringify(monitoryExclusion);
        return this.http.post(`${environment.urlBackend}${environment.solicitarExclusaoFicha}`,json, {headers}); 
    }


}
